import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { forgotPassword } from "../../redux/actions/auth";

// Validation schema
const schema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
});

const ForgotPassword = ({ show, onHide, openEnterOtp }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: {
      email: "",
    },
  });

  // ************* UPDATED SUBMIT FUNCTION *************
  const onSubmit = async (data) => {
    try {
      const res = await dispatch(forgotPassword({ email: data.email }));
      const result = res.payload; // <-- FIX
      console.log(result);
      
      if (result?.success) {
        toast.success(result?.message || "A reset link has been sent to your email");
        onHide();
      } else {
        toast.error(result?.message || "Failed to send reset link");
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  // ****************************************************

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0" />
      <Modal.Body className="pt-0">
        <div className="commn-modal-signin">
          <h2>Forgot Password?</h2>
          <p>
            It was popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum.
          </p>

          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* Email */}
            <Form.Group className="mb-3" controlId="forgotEmail">
              <Form.Control
                type="email"
                placeholder="Email"
                {...register("email")}
              />
              {errors.email && (
                <p
                  className="text-danger"
                  style={{ textAlign: "left", marginTop: "5px" }}
                >
                  {errors.email.message}
                </p>
              )}
            </Form.Group>

            {/* Continue Button */}
            <div className="d-grid gap-2">
              <button type="submit" className="btn btn-primary">
                Continue
              </button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPassword;
